import {Dispatch} from 'redux';

import Types from '../Types';

import AppState from '../../reducers/AppState';

import showGeneric from '../generics/show';

import SoundCategory from '../../../domain/entities/SoundCategory';

import NetSoundCategoriesRepository from '../../../data/repositories/NetSoundCategoriesRepository';

const types = {
  failure: Types.ShowSoundCategoryFailure,
  request: Types.ShowSoundCategoryRequest,
  success: Types.ShowSoundCategorySuccess,
};

export default function action(
  id: number,
): (
  dispatch: Dispatch<any>,
  getState: () => AppState,
) => Promise<SoundCategory> {
  return showGeneric(new NetSoundCategoriesRepository(), types, id);
}
